import type { RouteRecordRaw } from 'vue-router'
import { defaultRoutes } from '@hatfieldmedia/hmcore'

// Routes are defined separately so they can be imported by vite.config.ts
// for sitemap generation without triggering router creation
export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
    meta: {
      sitemap: { priority: 1.0 },
    },
  },
  // Add more routes with lazy loading for code splitting:
  // {
  //   path: '/about',
  //   name: 'about',
  //   component: () => import('@/views/AboutView.vue'),
  //   meta: {
  //     sitemap: { priority: 0.8, changefreq: 'monthly' },
  //   },
  // },
  // {
  //   path: '/admin',
  //   name: 'admin',
  //   component: () => import('@/views/AdminView.vue'),
  //   meta: {
  //     sitemap: { exclude: true }, // Exclude from sitemap
  //   },
  // },
  // Default HMCore routes (footer pages + 404 catch-all) - must be last
  ...defaultRoutes,
]
